import axios from "axios"
import { baseURL, config, getToken, requestID } from "../../common/utils"

export const getProducts = async () => {

    const payload = {
        requestID: requestID()
    }

    try {
        const res = axios.post(`${baseURL}warehouses/getAllProduct_trf`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getBarInventory_sales_branch = async (start_date, end_date, selectedBranch) => {
    const data = {
        requestID: requestID(),
        start_date,
        end_date,
        selectedBranch
    };
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventory_sales_branch`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
}


export const getBarInventory_sales = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventory_sales`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
}




export const getStewardInventory_report = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const res = await axios.post(`${baseURL}warehouses/getStewardInventory`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};




export const getBarInventoryByBusiness = async () => {
    const data = {
        requestID: requestID(),
    };

  //console.log(getToken());
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventoryByBusiness`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};




export const getBarInventoryByBranch_byRole = async () => {
    const data = {
        requestID: requestID(),
    };

  //console.log(getToken());
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventoryByBranch_byRole`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};


export const getBarInventoryByBranch_hotel = async () => {
    const data = {
        requestID: requestID(),
    };

  //console.log(getToken());
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventoryByBranch_hotel`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};


export const getBarInventoryByBranch_empty = async () => {
    const data = {
        requestID: requestID(),
    };

  //console.log(getToken());
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventoryByBranch_empty`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};



export const getBarInventoryByBranch_less_category = async () => {
    const data = {
        requestID: requestID(),
    };

  //console.log(getToken());
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventoryByBranch_less_rooms_category`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};
export const getBarInventoryByBranch = async () => {
    const data = {
        requestID: requestID(),
    };

  //console.log(getToken());
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventoryByBranch`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};
export const getBarInventory = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const res = await axios.post(`${baseURL}warehouses/getBarInventory`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};
export const getStewardInventory = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const res = await axios.post(`${baseURL}warehouses/getStewardInventory`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        console.log(error)
        return error
    }
};

export const getCategories = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const res = await axios.post(`${baseURL}warehouses/getCategories`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};